import React from "react";
import logo from "../assets/logo.svg";
import menu from "../assets/icon-hamburger.svg";
import "./Home/mobileHome.css";

function MobileTopbar() {
  const showMenu = () => {
    document.querySelector(".menu-container").style.opacity = "100%";
    document.querySelector(".menu-container").style.visibility = "visible";
  };
  return (
    <div className="topbar">
      <img onClick={showMenu} className="logo" src={logo} alt="logo" />
      <img className="menu" src={menu} alt="menu" onClick={showMenu}/>
    </div>
  );
}

export default MobileTopbar;
